import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import Cart from './Componet/Cart';
import Header from './Componet/Header';
import Products from './Componet/Products';

function App() {
  return (
   
      <BrowserRouter>
      <Header/>
        <Routes>
          <Route path='/' element={<Products/>} ></Route>
          <Route path='/cart' element={<Cart/>}></Route>
          <Route></Route>
        </Routes>
      </BrowserRouter>
    
  );
}

export default App;
